import {Component} from '@angular/core';
import {MaProductWidgetComponent} from '@ma-dashboard/ma-dashboard-products/ma-product-widget/ma-product-widget.component';
import {ProductListComponent} from '@app/product-list/product-list.component';

@Component({
  selector: 'app-ma-dashboard-products',
  templateUrl: './ma-dashboard-products.component.html',
  styleUrls: ['./ma-dashboard-products.component.scss'],
  standalone: true,
  imports: [ProductListComponent, MaProductWidgetComponent],
})
export class MaDashboardProductsComponent {}
